import type { MouseEvent } from 'react';

/**
 * Props for a modal overlay that closes on a click OUTSIDE the dialog,
 * without eating work when the click merely *ended* outside it.
 *
 * The old `onClick={close}` closed on any click whose target was the overlay.
 * But a click fires wherever the mouse is RELEASED: select text inside a
 * textarea, drag left past the dialog edge, let go, and the modal closed,
 * taking everything typed with it. Whiteknights hit this editing a team
 * description ("I move the cursor left and up the screen and the window
 * closes and I lose anything I've done").
 *
 * So we require the gesture to both START and END on the overlay.
 *
 * Module-scoped rather than component state on purpose: only one mouse
 * gesture is ever in flight, and a re-render between mousedown and click
 * would reset a useRef/useState living in the component.
 */
let gestureStart: EventTarget | null = null;

export function overlayClose(onClose: () => void) {
  return {
    onMouseDown: (e: MouseEvent) => {
      gestureStart = e.target;
    },
    onClick: (e: MouseEvent) => {
      const startedOnOverlay = gestureStart === e.currentTarget;
      gestureStart = null;
      if (startedOnOverlay && e.target === e.currentTarget) onClose();
    },
  };
}
